module.exports = __webpack_public_path__ + "static/media/xlsx-icon.387df198.svg";